module.exports = __webpack_public_path__ + "static/media/inf_17og18.4d6ba40c.mp3";